import React from 'react'
import { cn } from '@/lib/utils'

interface NativeDatePickerProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
  onChange?: (date: Date | undefined) => void
  value?: Date | string
  min?: string
  max?: string
}

export function NativeDatePicker({
  className,
  onChange,
  value,
  min,
  max,
  ...props
}: NativeDatePickerProps) {
  // Convert Date object to string format for input
  const formatDateForInput = (date: Date | string | undefined): string => {
    if (!date) return ''
    if (typeof date === 'string') {
      // Check if it's already in YYYY-MM-DD format
      if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return date
      // Try to parse the string to a Date
      const parsedDate = new Date(date)
      return !isNaN(parsedDate.getTime()) 
        ? parsedDate.toISOString().split('T')[0]
        : ''
    }
    return date.toISOString().split('T')[0]
  }

  const formattedValue = formatDateForInput(value)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      const newValue = e.target.value
      if (newValue) {
        onChange(new Date(newValue))
      } else {
        onChange(undefined)
      }
    }
  }

  return (
    <input
      type="date"
      className={cn(
        "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium",
        "placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      value={formattedValue}
      onChange={handleChange}
      min={min}
      max={max}
      {...props}
    />
  )
}
